import styled from '@emotion/styled';
import { useMaterialUIController } from 'context';
import React from 'react';

function CustomText({ children, ...props }) {
  const [controller] = useMaterialUIController();
  const { darkMode  } = controller;
  const Text = styled[props.type]`
    ${props.size && `font-size: ${props.size}px;`}
    text-align: ${props.center ? 'center' : props.justify ? 'justify' :props.right ? 'right' : 'left'} !important;
    ${props.color && `color: ${props.color};`}
    ${props.bold && `font-weight: bold;`}
    ${props.weight && `font-weight:  ${props.weight};`}
  `;
  return <Text style={darkMode?{color:"white"}:{color:"black"} }  className={props.className} {...props}>{children}</Text>;
}

export default CustomText;
